import styled from 'styled-components';

import { IToggleContainer } from './types';

export const Slider = styled.div`
  &::before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 1px;
    bottom: 3px;
    border-radius: 50%;
    background-color: ${Styles.color.white};
    pointer-events: none;
    transition: 0.2s ease-out transform;
  }
`;

export const ToggleContainer = styled.div<IToggleContainer>`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
  border-radius: 50px;
  background-color: ${p => {
    if (p.disabled) {
      return p.checked ? '#E54861' : '#979797';
    }
    return p.checked ? Styles.color.primary : Styles.color.grey.one;
  }};

  & > ${Slider}::before {
    transform: translateX(${p => (p.checked ? 26 : 2)}px);
  }
`;

export const HiddenInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;

  &[disabled] {
    cursor: not-allowed;
  }
`;
